import { Skeleton, Box, Stack, tokens } from '@cast/design-system';

export const RestrictionsLoadingSkeleton = () => {
  return (
    <Box overflow="auto" height="100%" pt={24}>
      <Stack gap={0}>
        {[1, 2, 3].map((categoryIndex) => (
          <Stack key={categoryIndex} gap={0}>
            <Box
              sx={{
                backgroundColor: tokens.theme.bg.structural.surfaceRaised,
                py: 6,
                px: 32,
                minHeight: 24,
              }}
            />
            <Stack gap={0}>
              {[1, 2].map((itemIndex) => (
                <Box
                  key={itemIndex}
                  sx={{
                    px: 32,
                    py: 8,
                    backgroundColor: 'transparent',
                  }}
                >
                  <Box
                    sx={{
                      width: '85%',
                      height: 40,
                      backgroundColor: tokens.theme.bg.loading.skeleton,
                      opacity: 0.4,
                      borderRadius: '2px',
                    }}
                  />
                </Box>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export const YamlPreviewLoadingSkeleton = () => {
  return (
    <Box
      height="100%"
      overflow="hidden"
      sx={{
        backgroundColor: tokens.theme.bg.structural.code,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: 24, pt: 24, pb: 0 }}>
        <Skeleton
          width={120}
          height={20}
          sx={{
            borderRadius: '4px',
            backgroundColor: tokens.theme.fg.structural.secondaryOnInverse,
          }}
        />
      </Box>
      <Box flexGrow={1} overflow="auto" position="relative">
        <Box sx={{ px: 24, py: 24 }}>
          <Stack gap={2}>
            {[60, 80, 70, 90, 65, 75, 85, 70, 80, 90].map((width, i) => (
              <Skeleton
                key={i}
                width={`${width}%`}
                height={20}
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                }}
              />
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
